import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
    FaCalendarAlt,
    FaStar,
    FaUsers,
} from "react-icons/fa";

const SocialCalendar = () => {

    const [open, setOpen] =
        useState(false);

    const calendarData = [

        { date: "JAN 04", event: "OIL CONSERVATION DAY" },
        { date: "JAN 04", event: "WORLD BRAILLE DAY" },
        { date: "JAN 10", event: "ROAD SAFETY WEEK" },
        { date: "JAN 12", event: "NATIONAL YOUTH DAY" },
        { date: "JAN 15", event: "ARMY DAY" },
        { date: "JAN 23", event: "NATIONAL DAY OF PATRIOTISM" },
        { date: "JAN 25", event: "INDIA TOURISM DAY" },
        { date: "JAN 26", event: "INDIAN REPUBLIC DAY" },
        { date: "JAN 26", event: "INTERNATIONAL CUSTOMS DAY" },
        { date: "JAN 27", event: "WORLD LEPROSY DAY" },
        { date: "JAN 30", event: "MARTYRS DAY" },

        { date: "FEB 01", event: "INTERNATIONAL DEVELOPMENT WEEK" },
        { date: "FEB 02", event: "WORLD WETLANDS DAY" },
        { date: "FEB 02", event: "CANCER SURVIVORS DAY" },
        { date: "FEB 11", event: "WORLD DAY OF THE SICK" },
        { date: "FEB 18", event: "FESTIVAL OF WOMEN AS ULTIRATORS" },
        { date: "FEB 21", event: "INTERNATIONAL MOTHER LANGUAGE DAY" },
        { date: "FEB 24", event: "CENTRAL EXCISE DAY" },
        { date: "FEB 28", event: "NATIONAL SCIENCE DAY" },

        { date: "MAR 01", event: "UNIVERSAL HUMAN BEINGS WEEK" },
        { date: "MAR 04", event: "NATIONAL SAFETY WEEK" },
        { date: "MAR 04", event: "INTERNATIONAL WOMEN'S WEEK" },
        { date: "MAR 07", event: "WORLD SUSTAINABLE ENERGY DAY" },
        {
            date: "MAR 08",
            event: "U.N. DAY FOR WOMEN'S RIGHTS & INTERNATIONAL PEACE",
        },
        { date: "MAR 10", event: "COMMON WEALTH DAY" },
        { date: "MAR 15", event: "WORLD CONSUMER RIGHTS DAY" },
        { date: "MAR 21", event: "WORLD FORESTRY DAY" },
        { date: "MAR 22", event: "WORLD WATER DAY" },
        { date: "MAR 27", event: "WORLD TEACHER DAY" },

        { date: "APRIL 01", event: "PREVENTION OF BLINDNESS WEEK" },
        { date: "APRIL 07", event: "HANDLOM WEEK" },
        { date: "APRIL 13", event: "JALIANWALA BAGH MASSACRE" },
        { date: "APRIL 14", event: "CUSTOMS DAY" },
        { date: "APRIL 22", event: "WORLD EARTH DAY" },
        { date: "APRIL 29", event: "INTERNATIONAL DANCE DAY" },

        { date: "MAY 01", event: "MAY DAY" },
        { date: "MAY 08", event: "WORLD RED CROSS DAY" },
        { date: "MAY 11", event: "NATIONAL TECHNOLOGY DAY" },
        { date: "MAY 31", event: "WORLD TOBACCO DAY" },

        { date: "JUNE 05", event: "WORLD ENVIRONMENT DAY" },
        { date: "JUNE 26", event: "FESTIVAL OF WOMEN AS ULTIRATORS" },
        { date: "JUNE 27", event: "WORLD DIABETES DAY" },

        { date: "JULY 11", event: "WORLD POPULATION DAY" },

        { date: "AUG 06", event: "HIROSHIMA DAY" },
        { date: "AUG 09", event: "NAGASAKI DAY" },
        { date: "AUG 15", event: "INDIAN INDEPENDANCE DAY" },
        { date: "AUG 20", event: "SADBHAVANA DIWAS" },
        { date: "AUG 26", event: "WOMEN'S EQUALITY DAY" },

        { date: "SEPT 01", event: "NATIONAL NUTRITION WEEK" },
        { date: "SEPT 05", event: "TEACHER'S DAY" },
        { date: "SEPT 08", event: "INTERNATIONAL LITERACY DAY" },
        { date: "SEPT 14", event: "SANCHAYIKA DAY" },
        { date: "SEPT 14", event: "HINDI DIWAS" },
        { date: "SEPT 22", event: "ROSE DAY" },
        { date: "SEPT 27", event: "WORLD TOURISM DAY" },

        { date: "OCT 01", event: "WILDLIFE WEEK" },
        { date: "OCT 03", event: "WORLD HABITAL DAY" },
        { date: "OCT 29", event: "UNO DAY" },

        { date: "NOV 08", event: "WORLD QUALITY DAY" },
        { date: "NOV 13", event: "WORLD KINDNESS DAY" },
        { date: "NOV 15", event: "WORLD HERITAGE WEEK" },
        { date: "NOV 20", event: "CHILD RIGHTS DAY" },
        { date: "NOV 23", event: "WORLD MOTHER IN LAW'S DAY" },
        {
            date: "NOV 30",
            event: "INTERNATIONAL COMPUTER SECURITY DAY",
        },

        { date: "DEC 01", event: "WORLD AIDS DAY" },
        { date: "DEC 10", event: "WORLD HUMAN RIGHTS DAY" },

    ];

    return (

        <>
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <section className="w-full bg-[#f7f9fc] overflow-x-hidden">

                {/* HERO */}
                <div className="bg-gradient-to-r from-[#072F5F] to-[#0B4F9C] py-16 md:py-20">

                    <div className="max-w-7xl mx-auto px-5 md:px-10 text-center">

                        <span className="text-[#D4A017] uppercase tracking-[4px] text-xs md:text-sm font-semibold">

                            Academic Calendar

                        </span>

                        <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-4">

                            Social Calendar

                        </h1>

                        <p className="text-gray-200 text-base md:text-lg mt-5 max-w-3xl mx-auto leading-8">

                            Important festivals, awareness days and social
                            events celebrated throughout the academic year.

                        </p>

                    </div>

                </div>

                {/* MAIN CONTENT */}
                <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">

                    {/* TOP CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">

                        {/* CARD 1 */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            <div className="w-14 h-14 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-xl shrink-0">

                                <FaCalendarAlt />

                            </div>

                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Throughout Year

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 text-[15px]">

                                    January - December Events

                                </p>

                            </div>

                        </div>

                        {/* CARD 2 */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            <div className="w-14 h-14 rounded-xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-xl shrink-0">

                                <FaStar />

                            </div>

                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Various Events

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 text-[15px]">

                                    Festivals & Awareness Days

                                </p>

                            </div>

                        </div>

                        {/* CARD 3 */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            <div className="w-14 h-14 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-xl shrink-0">

                                <FaUsers />

                            </div>

                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    School Community

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 text-[15px]">

                                    Together We Celebrate

                                </p>

                            </div>

                        </div>

                    </div>

                    {/* TABLE SECTION */}
                    <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">

                        {/* TABLE HEADER */}
                        <div className="bg-[#072F5F] px-6 py-5">

                            <h2 className="text-3xl md:text-4xl font-extrabold text-white">

                                Social Events Calendar

                            </h2>

                        </div>

                        {/* TABLE */}
                        <div className="overflow-x-auto">

                            <table className="w-full min-w-[700px]">

                                <thead className="bg-[#0B4F9C] text-white">

                                    <tr>

                                        <th className="px-6 py-4 text-left text-lg font-bold border-r border-white/20">

                                            Date

                                        </th>

                                        <th className="px-6 py-4 text-left text-lg font-bold">

                                            Festivals Or Events

                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {
                                        calendarData.map(
                                            (
                                                item,
                                                index
                                            ) => (

                                                <tr
                                                    key={index}
                                                    className="
                                                        border-b
                                                        border-gray-100
                                                        hover:bg-[#f7f9fc]
                                                        transition-all
                                                        duration-200
                                                    "
                                                >

                                                    <td className="px-6 py-4 font-bold text-[#0B4F9C] whitespace-nowrap">

                                                        {item.date}

                                                    </td>

                                                    <td className="px-6 py-4 text-gray-700 font-medium">

                                                        {item.event}

                                                    </td>

                                                </tr>
                                            )
                                        )
                                    }

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />
        </>
    );
};

export default SocialCalendar;